import ajax from './_ajax';

const api = {};
api.getRecommendedManufacturers = function () {
  return ajax.get('/api/Manufacturer/GetRecommendedManufacturers');
};
api.getManufacturers = function (params) {
  return ajax.post('/api/Manufacturer/GetManufacturers', params);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/manufacturerApi.js